export * as commonConfig from "./common";
